import { useEffect, useState } from 'react';
import { theme } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { useNavigate } from 'react-router-dom';
import SignUpService from 'services/signup';
import { useApp } from 'contexts/app';

const signUpService = new SignUpService();

const useRegister = () => {
  const { token } = theme.useToken();
  const [form] = useForm();
  const [otpForm] = useForm();
  const { showLoading } = useApp();

  const navigate = useNavigate();
  const [idOtp, setIdOtp] = useState();
  const [isShowOtp, setIshowOpt] = useState(false);

  useEffect(() => {
  }, []);

  const handleCreate = () => {
    form.submit();
  };

  const onFinish = async () => {
    const data = { ...form.getFieldsValue() };
    showLoading(true);
    const { otp } = await signUpService.signupWithPhone(data);
    setIdOtp(otp.id);
    showLoading(false);
    setIshowOpt(true);
  };

  const onOtpFinish = async () => {
    const data = { ...otpForm.getFieldsValue() };
    showLoading(true);
    try {
      const createdUser = await signUpService.createWithOTP({ id: idOtp, otp: data.otp });
      if (createdUser) {
        navigate('/thank-you');
      }
    } catch (error) {
      alert(error.message);
    }

    showLoading(false);
  };

  const phoneValidator = async (_, value) => {
    return new Promise(async (resolve, reject) => {
      try {
        const data = await signUpService.checkPhone(value);
        if (data.error) {
          reject(new Error('Số điện thoại này đã được đăng ký rồi'));
          return;
        }
        resolve();
      } catch (error) {
        reject(new Error('Không thể kiểm tra số điện thoạii'));
      }
    });
  };

  return {
    token,
    form,
    otpForm,
    navigate,
    isShowOtp,
    setIshowOpt,
    handleCreate,
    onFinish,
    onOtpFinish,
    phoneValidator,
  };
};

export default useRegister;
